import { render } from "./FeriadoShow.vue?vue&type=template&id=40cb3c3a"
import script from "./FeriadoShow.vue?vue&type=script&lang=js"
export * from "./FeriadoShow.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__